import { createClient } from '@supabase/supabase-js'

/**
 * Cliente Supabase del frontend MapeoData (GoTrue auth, DEC-003).
 *
 * Apunta al stack self-hosted MapeoData (https://db.mapeodata.com por
 * default — en dev se puede sobrescribir vía VITE_SUPABASE_URL).
 *
 * El `anon_key` está expuesto al navegador (es público por diseño en
 * Supabase). Verificar que el `SUPABASE_SERVICE_KEY` (privado) NUNCA
 * llega al frontend — vive solo en `backend/.env`.
 */

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://db.mapeodata.com'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

if (!supabaseAnonKey) {
  console.warn(
    '[SUPABASE] VITE_SUPABASE_ANON_KEY no configurada en .env. Auth no funcionará hasta que el CEO la rellene desde el password manager.',
  )
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
